import { Button, squareBlockCSS } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

export const SSidebarButton = styled(Button)(
  ({ theme }) => css`
    ${squareBlockCSS(32)};
    flex-shrink: 0;
    min-width: 32px;
    padding: 6px;
    border: 0;
    border-radius: 8px;

    .MuiButton-icon {
      margin: 0;
    }

    .MuiButton-icon svg {
      width: 20px;
      height: 20px;
      color: ${theme.palette.grey[400]};
      transition: color ${theme.transitions.duration.shortest}ms;
    }

    &:hover,
    &:focus-visible {
      background-color: ${theme.palette.grey[50]};

      .MuiButton-icon svg {
        color: ${theme.palette.grey[700]};
      }
    }
  `,
);
